import React, { useEffect } from 'react'

import AnalyzerCommonFilters from "Pages/AnalyzersV2/Filters"
import { useAnalyzerLorFilters } from "Pages/AnalyzersV2/Lor/@hooks"
import { lorSchema } from "Pages/AnalyzersV2/Lor/schema"
import {includeProviders, mainSite, mainSiteProvider, offices, reports, searchID, userData} from "@signals"


export default function LorFilters() {
	const { onSubmit, isValid, errorRegistry } = useAnalyzerLorFilters()

	useEffect(() => {
		mainSiteProvider.value = false
		includeProviders.value = userData.value?.WebProviderAnalyzerGroupDefault
		mainSite.value = null
	}, [reports.value, offices.value, searchID.value])

	return <AnalyzerCommonFilters
		components={{
			mainSite: !mainSiteProvider.value && (!!offices.value && !!reports.value || searchID.value),
			mainProvider: !!mainSiteProvider.value && (!!offices.value && !!reports.value || searchID.value),
			lengthRental: !mainSiteProvider.value && (!!offices.value && !!reports.value),
		}}
		compProps={{
			sites: {},
			lengthRental: { multiple: true, autoSelect: false, disableClearable: false},
			dates: { grid: { xs: 1.5 } },
            currency: { grid: { xs: 1.5 } }
		}}
		onSubmit={onSubmit}
		schema={lorSchema}
		isValid={isValid}
		errors={errorRegistry}
	/>
}